import {useMemo} from 'react';

export const useLazyValue = <T extends Record<string | symbol, unknown>>(
    getValue: () => T,
    deps: unknown[],
): T => {
    return useMemo(() => {
        const target = {} as T;
        let isInit = false;

        const handler =
            <K extends keyof ProxyHandler<T>>(key: K): NonNullable<ProxyHandler<T>[K]> =>
            (...args: unknown[]) => {
                if (!isInit) {
                    Object.assign(target, getValue());
                    isInit = true;
                }

                return (Reflect[key] as Function)(...args);
            };

        return new Proxy(target, {
            get: handler('get'),
            set: handler('set'),
            has: handler('has'),
            ownKeys: handler('ownKeys'),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
